import {NavbarSeparatorDefaultBox} from "./navbar-separator.default.box";

export const NavbarSeparatorBox = NavbarSeparatorDefaultBox;
